import Vue from 'vue';
import './plugins/toastify';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import './plugins/lightbox';
import './styles/auth-form-spacing.css';
import router from './router';
import store from './store';
import './store/broadcasterAdapter';
import '@/types';
import firebaseService from '@/service/upload/adapters/firebase';
import '@/service/renderingNotificator';
import uploadService from '@/service/upload';
import '@/service/chatSoundNotifier';
import '@/service/notificationSoundNotifier';
import '@/service/switchSoundNotifier';
import '@/service/buttonSoundNotifier';
import '@/service/tabSoundNotifier';
import VueTour from 'vue-tour';
import { awsS3UploadService } from './service/upload/adapters/awsS3';
import { getModule } from 'vuex-module-decorators';
import WelcomeMessageSetsModule from './store/modules/WelcomeMessageSets';

getModule(WelcomeMessageSetsModule, store); // bootstrap module to avoid ERR_STORE_NOT_PROVIDED error

Vue.use(VueTour);
Vue.config.productionTip = false;
Vue.config.ignoredElements = [
    'c'
];

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');

require('vue-tour/dist/vue-tour.css');

uploadService.addUploadService(firebaseService);
uploadService.addUploadService(awsS3UploadService);
